module.exports = __webpack_public_path__ + "static/media/avatar.a9ce91ce.svg";